import { useEffect, useRef } from 'react';

export function useUpdateEffect(callback:() => void, dependencies: unknown[]): void {
	const isMounted = useRef(false);

	useEffect(() => {
		if (isMounted.current) {
			return callback();
		}
		isMounted.current = true;
	}, dependencies);
}
